import { Features } from '../../../../../../../../../frontend/libs/shared/src/lib/types/features';

/**
 * injected in Angular ApplicationRoutesService
 */
export class ApplicationRoutesNgService {
  get(route: Route, ...args: Array<string | number>) {
    return replaceVars(route, args);
  }

  getCatalogCategoriesRoute(): string {
    return this.get(Route.CATALOG_CATEGORIES);
  }

  getParticipantsImpactMemberRoute(rfpId: number, memberId: number): string {
    return this.get(Route.RFP_IMPACT_MEMBER);
  }

  private static cleanRoute(route: Route) {
    let result = replaceVars(route, ['']);
    return result.replace('/aptitude/static/platform/', '');
  }

  public static compareUrlToRoute(url: string, route: Route) {
    return url.includes(this.cleanRoute(route));
  }
}

export enum Route {
  //SIGN-IN
  HOME_LANDING = '/aptitude/static/platform/home/landing',
  CHOOSE_ORG = '/aptitude/static/platform/signIn/choose-organization',
  CHOOSE_ORG_JS = '/aptitude/static/signIn.html#/chooseOrganization',
  RESET_PASSWORD = '/aptitude/static/platform/signIn/reset-password',
  RESET_PASSWORD_JS = '/aptitude/static/signIn.html#/resetPassword',
  CREATE_PASSWORD = '/aptitude/static/platform/signIn/create-a-new-password',
  CREATE_PASSWORD_JS = '/aptitude/static/signIn.html#/createANewPassword',
  TERMS_OF_USE = '/aptitde/static/platform/terms-of-use',
  TERMS_OF_USE_JS = '/aptitude/static/signIn.html#/termsOfUse',
  DESTINATION_FORWARDING_JS = '/aptitude/static/signIn.html#/destination',
  SIGN_IN = '/aptitude/static/platform/signIn',
  SIGN_IN_JS = '/aptitude/static/signIn.html#/',

  // HOME
  CREATE_RFP_JS = '/aptitude/static/home.html#/cards/BUYER_REQUEST/',
  EXECUTE_BUYER_JS = '/aptitude/static/home.html#/execute/view/cards/filter/activeOpportunities',
  EXECUTE_SELLER_JS = '/aptitude/static/home.html#/cards/SELLER_ACCEPT',
  EXECUTE_SELLER_JS_LIST_VIEW = '/aptitude/static/home.html#/list/SELLER_ACCEPT',
  HOME_CARDS_JS = '/aptitude/static/home.html#/cards',
  OFFER_JS = '/aptitude/static/home.html#/list/SELLER_OFFER',
  RECOMMENDED_SELLER_INITAITED_OFFER = '/aptitude/static/platform/home/list/recommendedSellerInitiatedOffer',
  RESPOND_SELLER = '/aptitude/static/platform/home/list/sellerRespond',
  OFFER_HISTORY_SELLER_JS = '/aptitude/static/home.html#/history/SELLER_OFFER',
  MANAGE_USERS = '/aptitude/static/platform/organization/settings/manageUsers',
  MANAGE_PATH = '/aptitude/static/platform/home/manageList',
  MANAGE_CONTRACTS_JS = '/aptitude/static/home.html#/manage/view/cards/filter/active',
  PARTICIPATION_JS = '/aptitude/static/home.html#/participation/',
  RESPOND_JS = '/aptitude/static/home.html#/cards/SELLER_RESPOND',
  RESPONSE_HISTORY_JS = '/aptitude/static/home.html#/history/SELLER_RESPOND',
  MY_ACCOUNT_JS = '/aptitude/static/myAccount.html',

  // CATALOG
  CATALOG_CATEGORIES = '/aptitude/static/platform/home/categories',
  CATALOG_PRODUCTS = '/aptitude/static/platform/catalog/products',
  CATALOG_PRODUCT_DETAIL = '/aptitude/static/platform/catalog/products/view/%productId%?categoryId=%categoryId%',
  CATALOG_PRODUCT_DETAILS_CATEGORIZATION = '/aptitude/static/platform/catalog/categorizationScheme/%categorizationSchemeId%/category/%categoryId%/product/%productId%',
  PRODUCTS_JS = 'aptitude/static/products.html#/',
  PRODUCT_DETAIL = '/aptitude/static/products.html#/view/productID/%productId%',
  EDIT_PRODUCT_DETAIL = '/aptitude/static/products.html#/edit/productID/%productId%',

  // RFP
  RFP_CATEGORIES = '/aptitude/static/platform/rfp/%rfpId%/categories',
  RFP_PARTICIPANTS = '/aptitude/static/platform/rfp/%rfpId%/participants',
  RFP_DETAILS = '/aptitude/static/platform/rfp/%rfpId%/details',
  RFP = `/aptitude/static/platform/rfp`,
  REVIEW_CONTRACTS_JS = '/aptitude/static/planning.html#/ppContracts/%rfpId%',
  RFP_IMPACT_MEMBER = '/aptitude/static/platform/purchase-planning/%rfpId%/buyer-member/%memberId%/impact',
  RFP_ACTIVE_OPPORTUNITIES = '/aptitude/static/home.html#/execute/view/list/filter/activeOpportunities',
  VIZIENT_BID_CALENDAR_PROD = '', //not provided yet
  VIZIENT_BID_MANAGEMENT_DEV = 'https://bidmanagement.dev.vizientinc.com',
  VIZIENT_BID_MANAGEMENT_QA = 'https://bidmanagement.test.vizientinc.com',
  VIZIENT_BID_MANAGEMENT_STAGE = 'https://bidmanagement.stage.vizientinc.com',
  VIZIENT_BID_MANAGEMENT_DEMO = '', //not provided yet
  VIZIENT_BID_MANAGEMENT_PROD = 'https://bidmanagement.vizientinc.com',

  //PURCHASE PLANNING
  REVIEW_CONTRACT = '/aptitude/static/platform/purchase-planning/%rfpId%/buyer/review/%cpaId%',

  // DOWNLOAD
  DOWNLOAD_PATH = '/aptitude/download/categories/%categoryId%/products',

  //Measurement
  MEASUREMENT_DETAILS = '/aptitude/static/platform/measurement/%contractId%/details',
  MEASUREMENT_DETAILS_JS = `/aptitude/static/compliance.html#/compliance/%contractId%`,
  MEASUREMENT_PERFORMANCE = `/aptitude/static/compliance.html#/compliance/%contractId%/performance`,
  MEASUREMENT_PARTICPANTS = `/aptitude/static/platform/measurement/%contractId%/participants`,
  MEASUREMENT_PARTICPANTS_JS = `/aptitude/static/compliance.html#/compliance/%contractId%/participants`,
  MEASUREMENT_CATEGORY = `/aptitude/static/platform/measurement/%contractId%/category`,
  MEASUREMENT_UNSPSCS_JS = `/aptitude/static/compliance.html#/compliance/%contractId%/unspscs`,
  MEASUREMENT_PRODUCTS = `/aptitude/static/platform/measurement/%contractId%/products`,
  MEASUREMENT_PRODUCTS_JS = `/aptitude/static/compliance.html#/compliance/%contractId%/products`,
  MEASUREMENT_DATA_SHARE = `/aptitude/static/compliance.html#/analytics/%contractId%`,
  MEASUREMENT_APT_DEX = '/aptitude/static/compliance.html#/aptdex/%contractId%',

  //ADMIN
  ADMIN_SIGN_IN = '/apt-admin/index.html#!/signIn',
  CPA_DETAILS = `/apt-admin/index.html#!/cpa/details/%contratId%`,
  CREATE_PRODUCT_CATEGORY = `/apt-admin/index.html#!/productCategory/edit/%categoryId%`,
}

export function replaceVars(
  routerLink: string,
  args: Array<string | number> = [],
) {
  let returnValue: string = routerLink;
  args.forEach((arg) => {
    returnValue = returnValue.replace(/%.+?%/, arg?.toString());
  });
  if (returnValue.includes('%')) {
    console.error(
      `${returnValue} still includes an argument, ensure all arguments are supplied`,
    );
  }
  return returnValue;
}
